module.exports = __webpack_public_path__ + "media/mosaics/Mosaic-Focus-3-8eca2b28.png";